module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("i8DDM"))).then(() => parcelRequire('iixVQ'));